<template>
  <div>
    <div class="vx-row">
      <div class="vx-col ml-auto mr-auto mb-base lg:w-9/12 w-full">
        <h2>Meterstanden</h2>
      </div>
      <div class="vx-col ml-auto mr-auto lg:w-9/12 w-full">
        <div class="vx-row">
          <div
            class="vx-col ml-auto mr-auto lg:w-1/2 w-full mb-base"
            v-for="connection in connections"
            :key="connection.id"
          >
            <meter-reading-card :id="connection.id"></meter-reading-card>
          </div>
        </div>
        <div class="vx-row" v-if="loading">
          <pulse-loader :loading="loading"></pulse-loader>
        </div>
        <div
          class="vx-row"
          v-if="!loading && (connections == null || connections.length == 0)"
        >
          <h5>Er konden geen meterstanden opgehaald worden</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../axios";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import MeterReadingCard from "../components/MeterReadingCard.vue";
export default {
  props: ["id"],
  components: { PulseLoader, MeterReadingCard },
  data() {
    return {
      connections: [],
      loading: true
    };
  },
  methods: {
    async getConnections() {
      try {
        let res = await axios().get(`api/contracts/${this.id}/connections`);
        this.connections = res.data;
        this.loading = false;
      } catch (ex) {
        this.loading = false;
      }
    }
  },
  async created() {
    await this.getConnections();
  }
};
</script>

<style></style>
